import React, { useState } from "react"
import { Button, Flex, Text } from "@chakra-ui/react"

import { GridItem } from "@/components"

const ApiCallForm = ({ setResponse, ...rest }) => {
    const [isLoading, setIsLoading] = useState(false)

    const handleClick = async () => {
        setIsLoading(true)
        const startTime = new Date().getTime()

        const res = await fetch(`${process.env.REACT_APP_API_URL}/api`)

        const endTime = new Date().getTime()
        const rtt = endTime - startTime

        setResponse({
            url: res.url,
            from: res.headers.get("response-from"),
            lookupTime: res.headers.get("X-Response-Time"),
            roundTripTime: rtt,
            status: res.status,
            statusText: res.statusText,
            body: await res.json(),
        })
        setIsLoading(false)
    }

    return (
        <GridItem {...rest}>
            <Flex justifyContent="flex-end" direction="column">
                <Text>
                    Upon clicking the Test API button for the first time, the API call will be
                    directed to the origin of the API. However, when you click the Test API button
                    for the second time, you'll experience the efficiency of cached responses (refer
                    to the request history for request time data). This caching mechanism optimizes
                    the response time, enhancing the overall performance of the API.
                </Text>
                <Button mt={4} onClick={handleClick} isLoading={isLoading} maxW="150px">
                    Test API Call
                </Button>
            </Flex>
        </GridItem>
    )
}

export { ApiCallForm }
